module.exports = __webpack_public_path__ + "static/media/colapse-icon.54c3a44b.svg";